export default {"src":"/_next/static/media/logo5.71a29b17.svg","height":116,"width":227};